import { useState } from 'react';
import { useIntl } from 'react-intl';

import type { FreeTextContentLinksType } from '@/components/Cms/FreeTextContent/FreeTextContent';
import { FreeTextContent } from '@/components/Cms/FreeTextContent/index';
import { Typography } from '@/components/Typography';
import type { ContentfulFaqWrapFragment } from '@/graphql/contentful/api';
import { paths } from '@/lib/paths';
import { messages } from '@/messages/faq';

import { Cta } from '../CTA';

import * as S from './FaqItem.styles';
type FaqAnswerType = NonNullable<
  NonNullable<ContentfulFaqWrapFragment['faqListCollection']>['items'][0]
>['faqAnswer'];
export interface FaqItemProps {
  faqAnswer?: FaqAnswerType;
  faqQuestion?: string;
  isFromFaqWrapCategories?: boolean;
}

export const FaqItem = ({
  faqAnswer,
  faqQuestion,
  isFromFaqWrapCategories,
}: FaqItemProps) => {
  const { formatMessage } = useIntl();

  const [isOpen, setIsOpen] = useState(false);
  const handleYesCta = () => {
    setIsOpen(false);
  };
  return (
    <S.StyledAccordion
      $isOpen={isOpen}
      isOpen={isOpen}
      onClick={() => setIsOpen(!isOpen)}
      title={
        <Typography
          data-test-id='FaqItemQuestion'
          fontFamily='openSans'
          textTransform='uppercase'
        >
          {faqQuestion}
        </Typography>
      }
    >
      <S.ContentWrapper data-test-id='FaqItemContentWrapper'>
        {faqAnswer?.json && faqQuestion && (
          <FreeTextContent
            freeTextContent={{
              __typename: 'FreeTextContentTextContent',
              json: faqAnswer.json,
              links: faqAnswer.links as FreeTextContentLinksType,
            }}
            sys={{ __typename: 'Sys', id: faqQuestion }}
          />
        )}
        {isFromFaqWrapCategories && (
          <>
            <Typography data-test-id='FaqItemAnswerMessage' mb={1} mt={1}>
              {formatMessage(messages.ifAnswered)}
            </Typography>
            <S.CtasWrapper>
              <Cta
                data-test-id='FaqItemYesCta'
                onClick={handleYesCta}
                url='#'
                urlText={formatMessage(messages.yesCta)}
                urlType=''
              />
              <Cta
                data-test-id='FaqItemNoCta'
                url={paths.service.contact.asPath()}
                urlText={formatMessage(messages.noCta)}
                urlType=''
              />
            </S.CtasWrapper>
            <S.NoteTypography
              data-test-id='FaqItemNoteMessage'
              fontFamily='openSans'
              mb={1}
              mt={1}
            >
              {formatMessage(messages.note)}
            </S.NoteTypography>
          </>
        )}
      </S.ContentWrapper>
    </S.StyledAccordion>
  );
};
